import { apiFetch } from '../../apiFetch'

export const getAdminUsers = async (
  paginate = {
    page: 1,
    limit: 15
  }
) => {
  return await apiFetch({
    path: `/admin/users?limit=${paginate.limit}&offset=${
      (parseInt(paginate.page) - 1) * parseInt(paginate.limit)
    }`
  })
}

export const getAdminUser = async (slug) => {
  return await apiFetch({
    path: `/admin/users/${slug}`
  })
}

export const putAdminUser = async (payload) => {
  return await apiFetch({
    method: 'PUT',
    path: `/admin/users/${payload.slug}`,
    payload
  })
}

export const postAdminUser = async (payload) => {
  return await apiFetch({
    method: 'POST',
    path: '/admin/users',
    payload
  })
}

export const assignUserLocation = async (payload) => {
  console.log({ payload })
  return await apiFetch({
    method: 'POST',
    path: '/admin/users_locations',
    payload
  })
}
